interface SectionHeaderProps {
  label: string
  color: 'blue' | 'indigo' | 'purple' | 'green' | 'orange' | 'pink' | 'gray'
}

const bgMap: Record<SectionHeaderProps['color'], string> = {
  blue:   'bg-blue-50',
  indigo: 'bg-indigo-50',
  purple: 'bg-purple-50',
  green:  'bg-green-50',
  orange: 'bg-orange-50',
  pink:   'bg-pink-50',
  gray:   'bg-gray-50',
}

const borderMap: Record<SectionHeaderProps['color'], string> = {
  blue:   'border-blue-500',
  indigo: 'border-indigo-500',
  purple: 'border-purple-500',
  green:  'border-green-500',
  orange: 'border-orange-500',
  pink:   'border-pink-500',
  gray:   'border-gray-500',
}

export function SectionHeader({ label, color }: SectionHeaderProps) {
  return (
    <tr className={bgMap[color]}>
      <td colSpan={6} className={`p-3 font-semibold text-sm border-l-4 ${borderMap[color]}`}>
        {label}
      </td>
    </tr>
  )
}
